// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: #f6efe3;
  width: 100%;
  height: 10vh;
  padding: 0 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 1px 3px 35px 0px rgba(80, 80, 80, 0.17);
  z-index: 3;
  position: relative;
  font-family: var(--font-family-second);
}
.header .left-area span {
  color: var(--color-black);
  letter-spacing: 4px;
  font-weight: bold;
  font-size: 1.5cqw;
  position: relative;
  padding-left: 1cqw;
}
.header .left-area span::after {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0.1cqw;
  height: 2.5cqw;
  background: #000;
  content: "";
}
.header .left-area {
  display: flex;
  align-items: center;
  position: relative;
}
.header .left-area img {
  width: 45%;
  margin-right: 1cqw;
}

.header .right-area {
  display: flex;
  align-items: center;
  font-size: 1cqw;
  font-weight: 600;
  width: 100%;
  justify-content: flex-end;
}
.header .right-area nav {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .right-area nav a {
  color: #000;
  margin-right: 20px;
}
.header .right-area nav a:hover {
  color: var(--color-third);
}
.profil-img {
  border-radius: 100%;
  overflow: hidden;
  border: 2px solid var(--color-first);
  display: none;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.hamburger div {
  height: 0.7cqw;
  background-color: var(--color-black);
  margin: 10% 0;
  transition-duration: 0.5s;
}
.hamburger div:nth-child(1) {
  width: 6cqw;
}

.hamburger div:nth-child(2) {
  width: 8cqw;
}

.hamburger div:nth-child(3) {
  width: 4cqw;
}
@media (max-width: 760px) {
  .header {
    height: 10vh;
    padding: 0 3%;
    position: relative;
    z-index: 1000;
  }
  .header .left-area {
    flex-direction: column;
  }
  .header .left-area span {
    font-size: 3.5cqw;
    border-top: 1px solid var(--color-black);
    line-height: 1;
  }
  .header .left-area span::after {
    width: 0;
  }
  .header .left-area img {
    width: 25cqw;
    margin-bottom: 2%;
  }
  .header .right-area {
    font-size: 2.25cqw;
    width: 100%;
    gap: 5%;
  }
  .header .right-area nav {
    display: none;
  }
  .hamburger {
    display: flex;
    align-items: flex-end;
  }
  .header .links {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5%;
    height: 100%;
  }
  .header .links a {
    color: var(--color-black);
    font-size: 5cqw;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mDAAmD;EACnD,UAAU;EACV,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,wCAAwC;IACxC,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,OAAO;EACT;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,OAAO;IACP,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".header {\n  background: #f6efe3;\n  width: 100%;\n  height: 10vh;\n  padding: 0 5%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 1px 3px 35px 0px rgba(80, 80, 80, 0.17);\n  z-index: 3;\n  position: relative;\n  font-family: var(--font-family-second);\n}\n.header .left-area span {\n  color: var(--color-black);\n  letter-spacing: 4px;\n  font-weight: bold;\n  font-size: 1.5cqw;\n  position: relative;\n  padding-left: 1cqw;\n}\n.header .left-area span::after {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 0.1cqw;\n  height: 2.5cqw;\n  background: #000;\n  content: \"\";\n}\n.header .left-area {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.header .left-area img {\n  width: 45%;\n  margin-right: 1cqw;\n}\n\n.header .right-area {\n  display: flex;\n  align-items: center;\n  font-size: 1cqw;\n  font-weight: 600;\n  width: 100%;\n  justify-content: flex-end;\n}\n.header .right-area nav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.header .right-area nav a {\n  color: #000;\n  margin-right: 20px;\n}\n.header .right-area nav a:hover {\n  color: var(--color-third);\n}\n.profil-img {\n  border-radius: 100%;\n  overflow: hidden;\n  border: 2px solid var(--color-first);\n  display: none;\n}\n\n.hamburger {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.hamburger div {\n  height: 0.7cqw;\n  background-color: var(--color-black);\n  margin: 10% 0;\n  transition-duration: 0.5s;\n}\n.hamburger div:nth-child(1) {\n  width: 6cqw;\n}\n\n.hamburger div:nth-child(2) {\n  width: 8cqw;\n}\n\n.hamburger div:nth-child(3) {\n  width: 4cqw;\n}\n@media (max-width: 760px) {\n  .header {\n    height: 10vh;\n    padding: 0 3%;\n    position: relative;\n    z-index: 1000;\n  }\n  .header .left-area {\n    flex-direction: column;\n  }\n  .header .left-area span {\n    font-size: 3.5cqw;\n    border-top: 1px solid var(--color-black);\n    line-height: 1;\n  }\n  .header .left-area span::after {\n    width: 0;\n  }\n  .header .left-area img {\n    width: 25cqw;\n    margin-bottom: 2%;\n  }\n  .header .right-area {\n    font-size: 2.25cqw;\n    width: 100%;\n    gap: 5%;\n  }\n  .header .right-area nav {\n    display: none;\n  }\n  .hamburger {\n    display: flex;\n    align-items: flex-end;\n  }\n  .header .links {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5%;\n    height: 100%;\n  }\n  .header .links a {\n    color: var(--color-black);\n    font-size: 5cqw;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
